export default __webpack_public_path__ + "static/media/PreRoleS3BucketAccessLogs.b05d09f5.md";